import React from 'react';
import { ImpactReportConfigurationForm } from './modules/ImpactReportConfigurationForm';

const ImpactReportPageComponent = () => {

  return (
    <div className={''}>
      <div>
        <ImpactReportConfigurationForm />
      </div>
    </div>
  );
};

export { ImpactReportPageComponent };

